import { render, staticRenderFns } from "./tender-detail.vue?vue&type=template&id=7377a94e&scoped=true"
import script from "./tender-detail.vue?vue&type=script&lang=js"
export * from "./tender-detail.vue?vue&type=script&lang=js"
import style0 from "./tender-detail.vue?vue&type=style&index=0&id=7377a94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7377a94e",
  null
  
)

export default component.exports